// This is more or less copied from nextpub VariationProvider.tsx, although I removed a couple of
// features that aren't relevant to our use case right now

import React, { ReactNode, useEffect, useState } from 'react';
import { VariationContextInterface } from './VariationContextInterface';
import { VariationContext } from './VariationContext';

// Global type augmentation for window.TTAM
type SetVariation = (variations: VariationContextInterface) => void;

declare global {
  interface Window {
    TTAM: {
      setVariation: SetVariation;
    };
  }
}

const defaultContextValue: VariationContextInterface = {};

export const TTAM_VARIATION_PROVIDER_DID_MOUNT_EVENT = 'ttamVariationProviderDidMount';

interface VariationProviderProps {
  children: ReactNode;
}

export const VariationProvider = ({ children }: VariationProviderProps) => {
  const [variations, setVariations] = useState(defaultContextValue);

  useEffect(() => {
    window.TTAM = window.TTAM || {};
    window.TTAM.setVariation = (newVariations: VariationContextInterface) => {
      setVariations((prevVariations) => ({
        ...prevVariations,
        ...newVariations,
      }));
    };

    // TEMP - Get variant from query params
    const urlParams = new URLSearchParams(window.location.search);
    const queryVariations: Partial<VariationContextInterface> = {};

    const validVariationKeys: Array<keyof VariationContextInterface> = [
      'paypalButtonLabel',
      'expressCheckoutLayout',
    ];
    // BKO-5333: expressCheckoutLayout is now a 3-way string cohort ('control'/'v1'/'v2'),
    // not a boolean — it passes through the raw string, not this coercion list.
    const booleanVariationKeys: Array<keyof VariationContextInterface> = [];

    const isValidVariationKey = (key: string): key is keyof VariationContextInterface => {
      return validVariationKeys.includes(key as keyof VariationContextInterface);
    };

    urlParams.forEach((value, key) => {
      const camelKey = key
        .replace(/[-_]([a-z])/g, (g) => g[1].toUpperCase())
        .replace(/^[a-z]/, (g) => g.toLowerCase());

      if (isValidVariationKey(camelKey)) {
        if (booleanVariationKeys.includes(camelKey)) {
          (queryVariations as Record<string, boolean>)[camelKey] = value === 'true';
        } else {
          (queryVariations as Record<string, string>)[camelKey] = value;
        }
      }
    });

    if (Object.keys(queryVariations).length > 0) {
      window.TTAM.setVariation(queryVariations);
    }
    // END TEMP

    // dispatch event for Optimizely to hook into
    document.dispatchEvent(new CustomEvent(TTAM_VARIATION_PROVIDER_DID_MOUNT_EVENT));
  }, []);

  return <VariationContext.Provider value={variations}>{children}</VariationContext.Provider>;
};
